// ===== FAB =====
let fabOpen=false;
let _quickActionsPage='dashboard';
function quickActionsStorageKey(){
  const org=window.MarmoriaSaaS?.state?.organizationId||'local',user=typeof firebase!=='undefined'&&typeof firebase.auth==='function'?firebase.auth().currentUser:null;
  return`operational_quick_area_${user?.uid||'guest'}_${org}`;
}
function quickActionsCanWrite(collection){
  return window.MARMORARIA_SAAS_MODE!==true||window.MarmoriaSaaS?.canCollection(collection,'write')===true;
}
function quickActionsContext(page=_quickActionsPage){
  let preferred='';try{preferred=localStorage.getItem(quickActionsStorageKey())||''}catch(e){}
  return window.OperationalQuickActions?.resolve({
    page,
    preferredArea:preferred,
    role:window.MarmoriaSaaS?.state?.membership?.role||'owner',
    contextMode:window.MarmoriaSaaS?.state?.contextMode||'legacy',
    canWrite:quickActionsCanWrite,
    limit:7
  })||{area:null,areas:[],actions:[]};
}
function renderQuickActions(page=_quickActionsPage){
  _quickActionsPage=page||'dashboard';
  const fab=document.getElementById('fab'),menu=document.getElementById('fab-menu');if(!fab||!menu)return;
  const ctx=quickActionsContext(_quickActionsPage);
  fab.hidden=!ctx.actions.length;
  if(fab.hidden){closeFab();menu.innerHTML='';return}
  const area=window.OperationalQuickActions.AREAS[ctx.area],selector=ctx.areas.length>1?`<select class="fab-area" aria-label="Área das ações rápidas" onchange="selecionarAreaAcoesRapidas(this.value)">${ctx.areas.map(item=>`<option value="${escapeHtml(item.id)}"${item.id===ctx.area?' selected':''}>${escapeHtml(item.label)}</option>`).join('')}</select>`:'';
  menu.innerHTML=`<div class="fab-head"><strong>Ações rápidas</strong><small>${escapeHtml(area?.label||'Área atual')} · somente ações autorizadas</small>${selector}</div>${ctx.actions.map(action=>`<button class="fab-opt" type="button" role="menuitem" data-quick-action="${escapeHtml(action.id)}" onclick="executarAcaoRapida('${escapeHtml(action.id)}')"><i class="ti ${escapeHtml(action.icon)}" aria-hidden="true"></i><span>${escapeHtml(action.label)}</span></button>`).join('')}`;
}
function selecionarAreaAcoesRapidas(area){
  try{localStorage.setItem(quickActionsStorageKey(),String(area||''))}catch(e){}
  renderQuickActions(_quickActionsPage);
}
const QUICK_ACTION_HANDLERS=Object.freeze({
  lead:()=>{showPage('leads');openModal('modal-lead')},
  quote:()=>novoOrcamento(),
  client:()=>{showPage('clientes');openClienteForm()},
  task:()=>openModal('modal-tarefa'),
  serviceOrder:()=>{showPage('os');openOSForm();openModal('modal-os')},
  measurement:()=>{showPage('medicao');openMedicaoForm()},
  stockItem:()=>{showPage('estoque');openEstoqueForm()},
  purchase:()=>{showPage('compras');openCompraForm()},
  supplier:()=>{showPage('fornecedores');openFornecedorForm()},
  cashEntry:()=>{showPage('caixa');openModal('modal-lancamento')},
  receivable:()=>{showPage('recebiveis');openModal('modal-recebivel')},
  payable:()=>{showPage('pagamentos');openModal('modal-pagamento')},
  review:()=>{showPage('pos-venda');openAvaliacaoForm()}
});
function executarAcaoRapida(id){
  const action=window.OperationalQuickActions?.ACTIONS?.[id],handler=QUICK_ACTION_HANDLERS[id];
  if(!action||!handler)return;
  try{exigirPermissaoColecao(action.collection,'write')}catch(e){renderQuickActions(_quickActionsPage);return}
  closeFab();handler();
}
function toggleFab(){
  renderQuickActions(_quickActionsPage);
  const fab=document.getElementById('fab');if(!fab||fab.hidden)return;
  fabOpen=!fabOpen;
  if(fabOpen)fecharPopoversCabecalho('fab');
  document.getElementById('fab-menu').classList.toggle('open',fabOpen);
  const btn=document.getElementById('fab-btn');btn.style.transform=fabOpen?'rotate(45deg)':'';btn.setAttribute('aria-expanded',String(fabOpen));btn.setAttribute('aria-label',fabOpen?'Fechar ações rápidas':'Abrir ações rápidas');
  if(fabOpen)document.querySelector('#fab-menu .fab-opt')?.focus();
}
function closeFab(){fabOpen=false;document.getElementById('fab-menu')?.classList.remove('open');const btn=document.getElementById('fab-btn');if(btn){btn.style.transform='';btn.setAttribute('aria-expanded','false');btn.setAttribute('aria-label','Abrir ações rápidas')}}
document.addEventListener('click',e=>{if(!document.getElementById('fab').contains(e.target))closeFab()});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&fabOpen){closeFab();document.getElementById('fab-btn')?.focus()}});

